module.exports = __webpack_public_path__ + "static/media/ic-1.37f50802.svg";